import React from 'react';
import './LoadingOverlay.css';

function LoadingOverlay({ show, message = 'Loading...' }) {
  if (!show) return null;

  return (
    <div className="overlay">
      <div className="loader"></div>
      {message && (
        <span style={{ marginTop: '1rem', color: 'white' }}>{message}</span>
      )}
    </div>
  );
}

export default LoadingOverlay;
